const deleteFeatureFlags = {
  toastr: 'Tenant actualizado',
  toastr1: ' fue actualizado con éxito',
  toastrError: 'Índice no encontrado'
};

export default deleteFeatureFlags;
